import { useTranslation } from "react-i18next";
const ModalMessage = ({ isOpen, onClose, message }) => {
    const { t } = useTranslation();

    return (
        <>
            {isOpen && (
                <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                    <div className="fixed inset-0 bg-gray-500 opacity-75"></div>
                    <div className="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
                        <div className="py-4 text-left px-6">
                            <div className="mb-4">
                                <p className="text-xl">{message}</p>
                            </div>
                            <div className="flex justify-end">
                                <button
                                    className="mr-4 inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                    onClick={onClose}
                                >
                                    {t('btn_cerrar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ModalMessage;